export default "__VITE_ASSET__CQzWIUdA__"